import clsx from "clsx";
import React from "react";
import * as styles from "./ContentWithSideCard.module.scss";

interface ContentWithSideCardProps {
  header?: JSX.Element;
  card?: JSX.Element;
}

const ContentWithSideCard: React.FC<
  React.PropsWithChildren<ContentWithSideCardProps>
> = ({ header, children, card }) => {
  return (
    <React.Fragment>
      {header && (
        <header
          className={clsx({
            [styles.headerCentered]: !!card
          })}
        >
          {header}
        </header>
      )}
      <div className={styles.container}>
        {card && <div className={styles.card}>{card}</div>}
        <div className={styles.content}>{children}</div>
      </div>
    </React.Fragment>
  );
};

export default ContentWithSideCard;
